import React from 'react';
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  TextArea,
  UncontrolledTooltip,
} from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class CustomeSiteMockUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectSizeIsOpen: false,
      tShirtSize: '',
      yourText: '',
      emailOficial: '',
      lastNameOficial: '',
      firstNameOficial: '',
      isRequired: false,
      emailFalse: false,
      seeMore: false,
      editYourText: false,
      editSize: false,
      editEmail: false,
      editLastName: false,
      editFirstName: false,
      getUserVerification: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.customerSiteMockUp && this.state.getUserVerification) {
      // if the component is not displayed again, comment this line.
      this.props.getCustomerSiteMockUp(nextProps.user.id);
      this.setState({
        getUserVerification: false,
      });
    }
  }

  handleText = (value) => {
    this.setState({
      yourText: value,
    });
  };

  saveButtom = () => {
    const customer = {
      yourText: this.state.yourText,
      tShirtSize: this.state.tShirtSize,
      firstName: this.state.firstNameOficial,
      lastName: this.state.lastNameOficial,
      email: this.state.emailOficial,
    };
    this.props.setCustomerSiteMockUp(customer);

    this.setState({
      selectSizeIsOpen: false,
      tShirtSize: '',
      yourText: '',
      emailOficial: '',
      lastNameOficial: '',
      firstNameOficial: '',
      isRequired: false,
      emailFalse: false,
      seeMore: false,
    });

    this.props.getCustomerSiteMockUp(this.props.user.id);
  };

  handleSeeMore = () => {
    this.setState({
      seeMore: true,
    });
  };

  validateEmail(e) {
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({ emailOficial: e, emailFalse: false });
    if (emailRex.test(e)) {
      return true; // 'has-success'
    }
    this.setState({ emailFalse: true });

    return false; // 'has-danger'
  }

  handleEditText = () => {
    this.setState(
      {
        editYourText: !this.state.editYourText,
        yourText: this.props.customerSiteMockUp.yourText,
      },
      () => this.clickInput('TextArea'),
    );
  };

  clickInput = (inputName) => {
    const element = document.getElementById(inputName);
    if (element) {
      element.click();
      element.focus();
    }
  };

  checkEditText = () => {
    const userId = this.props.user.id;
    const value = { yourText: this.state.yourText };

    if (this.state.yourText === '') {
      this.setState({
        editYourText: !this.state.editYourText,
      });
    } else {
      this.setState({
        editYourText: !this.state.editYourText,
        getUserVerification: true,
      });

      this.props.setCustomerSiteMockUp(value);
    }
  };

  renderInputPersonalInformation = () => (
    <div className="field field-input">
      <div className="editsInputs">
        <textarea
          id="TextArea"
          rows="4"
          onChange={(e) => {
            e.target.value.trim()
              ? this.handleText(e.target.value)
              : this.handleText('');
          }}
          placeholder={
            this.props.customerSiteMockUp.yourText
              ? this.props.customerSiteMockUp.yourText.replace(/;/g, '\n')
              : '(Your text)'
          }
          value={this.state.yourText.replace(/;/g, '\n')}
          disabled={
            !this.state.editYourText && this.props.customerSiteMockUp.yourText
          }
        />
        {this.props.customerSiteMockUp.yourText && (
          <div>
            {!this.state.editYourText && (
              <i
                className="material-icons material-icons-outlined edit-icon"
                onClick={this.handleEditText}
              >
                edit
              </i>
            )}
            {this.state.editYourText && (
              <i
                className="material-icons edit-icon"
                onClick={this.checkEditText}
              >
                check
              </i>
            )}
          </div>
        )}
      </div>
      {this.state.yourText === '' && this.state.isRequired && (
        <span className="isRequired">(*) Required</span>
      )}
    </div>
  );

  sizeStatusClick = () => {
    this.setState({
      selectSizeIsOpen: !this.state.selectSizeIsOpen,
    });
  };

  sizeStatus = (option) => {
    this.setState({
      tShirtSize: option,
    });
  };

  handleEmail = (value) => {
    this.setState({
      emailOficial: value,
    });
  };

  handleLastNameOficial = (value) => {
    this.setState(
      {
        lastNameOficial: value,
      },
      () => this.clickInput('lastName'),
    );
  };

  handleFirstNameOficial = (value) => {
    this.setState({
      firstNameOficial: value,
    });
  };

  handleEditSize = () => {
    this.setState({
      editSize: !this.state.editSize,
    });
  };

  validateSize = () => {
    const userId = this.props.user.id;
    const value = { tShirtSize: this.state.tShirtSize };

    if (this.state.tShirtSize == '') {
      this.setState({
        editSize: !this.state.editSize,
      });
    } else {
      this.setState({
        editSize: !this.state.editSize,
        getUserVerification: true,
      });
      this.props.setCustomerSiteMockUp(value);
    }
  };

  renderSelectSize = () => {
    const size = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
    return (
      <div className="field field-input">
        <div className="shirtSize">
          <Col className="field-label">
            <strong>T-shirt Size</strong>
          </Col>

          {!this.props.customerSiteMockUp.tShirtSize || this.state.editSize ? (
            <div className="contentCenter">
              <Dropdown
                isOpen={this.state.selectSizeIsOpen}
                toggle={this.sizeStatusClick}
                className="my-profile-selector inputSize"
              >
                <DropdownToggle className="my-profile-dropdown-toggle">
                  <span className="option-title option-title-userVerification">
                    {this.state.tShirtSize ? this.state.tShirtSize : ``}
                  </span>
                  {this.state.selectSizeIsOpen ? (
                    <i className="icon-expand select-icon rotate down" />
                  ) : (
                    <i className="icon-expand select-icon rotate" />
                  )}
                </DropdownToggle>
                <DropdownMenu>
                  {size.map((option, index) => (
                    <DropdownItem
                      key={index}
                      className="drop-item drop-item-userVerification"
                      onClick={() => this.sizeStatus(option)}
                    >
                      {option}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {this.state.editSize &&
                this.props.customerSiteMockUp.tShirtSize && (
                  <i
                    className="material-icons edit-icon"
                    onClick={this.validateSize}
                  >
                    check
                  </i>
                )}
            </div>
          ) : (
            <div className="contentCenter">
              <Input
                className="inputSize"
                placeholder={
                  this.state.tShirtSize
                    ? this.state.tShirtSize
                    : this.props.customerSiteMockUp.tShirtSize
                }
                disabled
              />
              {!this.state.editSize &&
                this.props.customerSiteMockUp.tShirtSize && (
                  <i
                    className="material-icons material-icons-outlined edit-icon"
                    onClick={this.handleEditSize}
                  >
                    edit
                  </i>
                )}
            </div>
          )}
        </div>

        {this.state.tShirtSize === '' && this.state.isRequired && (
          <span className="isRequired">(*) Required</span>
        )}
      </div>
    );
  };

  handleEditEmailClick = () => {
    this.setState({
      editEmail: !this.state.editEmail,
      emailOficial: this.props.customerSiteMockUp.email,
    });
  };

  validateEmailOficial = () => {
    const userId = this.props.user.id;
    const value = { email: this.state.emailOficial };

    if (this.state.emailOficial === '' || this.state.emailFalse) {
      this.setState({
        emailFalse: true,
        editEmail: true,
      });
    } else {
      this.setState({
        editEmail: !this.state.editEmail,
        getUserVerification: true,
      });
      this.props.setCustomerSiteMockUp(value);
    }
  };

  handleEditLastNameClick = () => {
    this.setState({
      editLastName: !this.state.editLastName,
    });
  };

  validateLastNameOficial = () => {
    const userId = this.props.user.id;
    const value = { lastName: this.state.lastNameOficial };

    if (this.state.lastNameOficial === '') {
      this.setState({
        editLastName: !this.state.editLastName,
      });
    } else {
      this.props.setCustomerSiteMockUp(value);
      this.setState({
        editLastName: !this.state.editLastName,
        getUserVerification: true,
      });
    }
  };

  handleEditFirstNameClick = () => {
    this.setState({
      editFirstName: !this.state.editFirstName,
      firstNameOficial: this.props.customerSiteMockUp.firstName,
    });
  };

  validateFirstNameOficial = () => {
    const userId = this.props.user.id;
    const value = { firstName: this.state.firstNameOficial };

    if (this.state.firstNameOficial === '') {
      this.setState({
        editFirstName: !this.state.editFirstName,
      });
    } else {
      this.setState({
        editFirstName: !this.state.editFirstName,
        getUserVerification: true,
      });
      this.props.setCustomerSiteMockUp(value);
    }
  };

  inputsOficialMilitar = () => (
    <Row>
      <Col className="paddingCol" sm={12} md={4}>
        <div className="editInputOficial">
          <Input
            onChange={(e) => this.validateEmail(e.target.value.trim())}
            className="inputOficial"
            placeholder={
              this.props.customerSiteMockUp.email
                ? this.props.customerSiteMockUp.email
                : '(Your e-mail)'
            }
            value={this.state.emailOficial}
            disabled={
              !this.state.editEmail && this.props.customerSiteMockUp.email
            }
          />
          {!this.state.editEmail && this.props.customerSiteMockUp.email && (
            <i
              className="material-icons material-icons-outlined edit-icon"
              onClick={this.handleEditEmailClick}
            >
              edit
            </i>
          )}
          {this.state.editEmail && this.props.customerSiteMockUp.email && (
            <i
              className="material-icons edit-icon"
              onClick={this.validateEmailOficial}
            >
              check
            </i>
          )}
        </div>

        {this.state.emailOficial === '' && this.state.isRequired && (
          <div>
            <span className="isRequired">(*) Required</span>
            <br />
          </div>
        )}
        {this.state.emailFalse && (
          <span className="isRequired">(*) Enter a valid e-mail address</span>
        )}
      </Col>
      <Col className="paddingCol" sm={12} md={4}>
        <div className="editInputOficial">
          <Input
            id="lastName"
            onChange={(e) => {
              e.target.value.trim()
                ? this.handleLastNameOficial(e.target.value)
                : this.handleLastNameOficial('');
            }}
            className="inputOficial"
            placeholder={
              this.props.customerSiteMockUp.lastName
                ? this.props.customerSiteMockUp.lastName
                : '(Last Name)'
            }
            value={this.state.lastNameOficial}
            disabled={
              !this.state.editLastName && this.props.customerSiteMockUp.lastName
            }
          />
          {!this.state.editLastName &&
            this.props.customerSiteMockUp.lastName && (
              <i
                className="material-icons material-icons-outlined edit-icon"
                onClick={this.handleEditLastNameClick}
              >
                edit
              </i>
            )}
          {this.state.editLastName &&
            this.props.customerSiteMockUp.lastName && (
              <i
                className="material-icons edit-icon"
                onClick={this.validateLastNameOficial}
              >
                check
              </i>
            )}
        </div>

        {this.state.lastNameOficial === '' && this.state.isRequired && (
          <span className="isRequired">(*) Required</span>
        )}
      </Col>

      <Col className="paddingCol" sm={12} md={4}>
        <div className="editInputOficial">
          <Input
            onChange={(e) => {
              e.target.value.trim()
                ? this.handleFirstNameOficial(e.target.value)
                : this.handleFirstNameOficial('');
            }}
            className="inputOficial"
            placeholder={
              this.props.customerSiteMockUp.firstName
                ? this.props.customerSiteMockUp.firstName
                : '(First Name)'
            }
            value={this.state.firstNameOficial}
            disabled={
              !this.state.editFirstName && this.props.customerSiteMockUp.email
            }
          />

          {!this.state.editFirstName &&
            this.props.customerSiteMockUp.firstName && (
              <i
                className="material-icons material-icons-outlined edit-icon"
                onClick={this.handleEditFirstNameClick}
              >
                edit
              </i>
            )}
          {this.state.editFirstName &&
            this.props.customerSiteMockUp.firstName && (
              <i
                className="material-icons edit-icon"
                onClick={this.validateFirstNameOficial}
              >
                check
              </i>
            )}
        </div>

        {this.state.firstNameOficial === '' && this.state.isRequired && (
          <span className="isRequired">(*) Required</span>
        )}
      </Col>
    </Row>
  );

  render() {
    return (
      <div className="my-profile-component customer-site-mockup">
        <Row className="header">
          <div className="title">Want SWAG for being Advanced?</div>
        </Row>

        {this.props.loadingCustomerSite ? (
          <div className="loading-container">
            <CircularLoading className="loading-gif-waiting" />
          </div>
        ) : (
          <div>
            <Row className="header">
              <div>
                We occasionally want to send out promotional merchandise for
                customers who make rank or other milestones using our service.
                If you want to receive these types of items (coins, t-shirts,
                stickers, etc), please include your military mailing or personal
                address, including your formal name/rank. For example:
                <Row className="header examples">
                  <Col sm={12} md={4} lg={3}>
                    TSGT John P. Smith
                    <br />
                    Radiology Lab <br />
                    1100 Wilford Hall Loop
                    <br />
                    JBSA-Lackland, TX 78236 <br />
                  </Col>
                  <Col sm={12} md={1} lg={1}>
                    {' '}
                    OR{' '}
                  </Col>
                  <Col sm={12} md={4} lg={3}>
                    John P. Smith <br />
                    123 Smith Street <br />
                    Virginia Beach, VA 23452 <br />
                  </Col>
                </Row>
              </div>
            </Row>
            <Row className="text-size">
              <Col className="body" xl={8}>
                {this.renderInputPersonalInformation()}
              </Col>
              <Col className="body textCenter" xl={4}>
                {this.renderSelectSize()}
              </Col>
            </Row>

            <Row className="header">
              <div>
                When advancement results come out, we want to see if you are on
                it! Since your sign-up name and user name may not match what is
                on the Advancement List, please give us your military e-mail
                address and your OFFICIAL military name that we can compare to
                the advancement list.
              </div>
            </Row>
            <Row className="header">
              <div className="body">{this.inputsOficialMilitar()}</div>
            </Row>
            <Row className="header footer-text">
              <div>
                Note: We understand that military email addresses are for
                official use only. We will <strong>NOT</strong> be sending{' '}
                <strong>ANY</strong> promotional or product information to the
                e-mail address listed here unless you also use the same e-mail
                address as your log-in credentials for our free companion
                app/study site (not recommended). This email address will only
                be used to help verify that YOUR NAME is on the advancement list
                when they are released, and not for <strong>ANY</strong> form of
                communication.
              </div>
            </Row>
            <Row className="header rowCenter">
              {!this.props.customerSiteMockUp.yourText && (
                <Button
                  className="btn btn-primary btn-save"
                  onClick={() => {
                    if (
                      this.state.yourText === '' ||
                      this.state.tShirtSize === '' ||
                      this.state.lastNameOficial === '' ||
                      this.state.emailOficial === '' ||
                      this.state.firstNameOficial === '' ||
                      this.state.emailFalse
                    ) {
                      this.setState({ isRequired: true });
                    } else {
                      this.saveButtom();
                    }
                  }}
                >
                  {' '}
                  Save
                </Button>
              )}
            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default CustomeSiteMockUp;
